import { InlineComment } from '@amzn/awscat-pattern-library-service-model';
import { InlineTextFilter } from '../../../services/InlineTextOperations';

/** Comparing changes is expensive; throttle so rapid interactions batch into one resolution pass. */
export const CHANGES_MODIFIED_THROTTLE = 500;

/** By default, this Tiptap editor displays no inline edit, unless specified */
export const DEFAULT_INLINE_TEXT_FILTER: InlineTextFilter = { type: 'none' };

/**
 * State of the Popover dialog that points to a navigable item in the Tiptap editor.
 * Only one popover is shown at a time.
 */
export type PopoverState =
  | {
      readonly type: 'inline_edit';
      readonly target: DOMRect;
      readonly inlineEditId: string;
      readonly changeId: number;
      readonly shouldResolveInlineEdit: boolean;
    }
  | {
      readonly type: 'inline_comment';
      readonly target: DOMRect;
      readonly commentId: string;
      readonly nodeId: string | undefined;
      readonly comment: InlineComment;
      readonly isCommentOnDeletedText: boolean;
    };
